
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34233',
  depVersions: {
  "documents-public-ui": "static-1.34233",
  "client-types": "static-1.456",
  "documents-lib": "static-1.34238",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2022",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4921",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5488",
  "hs-test-utils": "static-1.7905",
  "hub-http": "static-1.6112",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11345",
  "I18n": "static-7.1600",
  "jasmine-immutable": "static-1.2911",
  "jasmine-runner": "static-1.6363",
  "lodash": "static-1.3",
  "quartz": "static-1.6860",
  "react": "static-7.184",
  "react-dlb": "static-1.76",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16548",
  "reporting-data": "static-1.66997",
  "reporting-testing-lib": "static-1.8930",
  "reporting-visualizations": "static-1.59073",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4663",
  "webpack-env": "static-1.54",
  "atom": "static-1.4964",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2387",
  "classnames": "static-2.10",
  "cssUtils": "static-1.766",
  "customer-data-filters-ui": "static-1.39324",
  "customer-data-objects": "static-1.7550",
  "customer-data-property-utils": "static-1.7977",
  "data-fetching-client": "static-1.9569",
  "enviro": "static-4.425",
  "FireAlarmUi": "static-1.4423",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85562",
  "FormUrlGenerator": "static-2.4613",
  "foundations-components": "static-1.7709",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11653",
  "icons": "static-2.639",
  "immutable": "static-2.76",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7053",
  "metrics-js": "static-1.9522",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.386",
  "property-description-translator": "static-1.3747",
  "property-translator": "static-1.5302",
  "quartz-config": "static-1.638",
  "quartz-core": "static-1.6079",
  "quick-fetch": "static-1.3828",
  "raven": "static-3.5808",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5261",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8060",
  "reference-resolvers-lite": "static-1.7983",
  "report-customization-components": "static-1.12820",
  "reporting-enablement": "static-1.22488",
  "reporting-reports": "static-1.66675",
  "reporting-snowflake": "static-1.55615",
  "reporting-ui-components": "static-2.64268",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4537",
  "sales-content-partitioning": "static-1.8831",
  "SalesContentIndexUI": "static-3.9074",
  "sanitize": "static-1.4366",
  "sanitize-text": "static-1.8038",
  "self-service-api": "static-1.10139",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1645",
  "signup-constants": "static-1.18643",
  "signup-ui-lego-core": "static-1.20653",
  "signup-ui-url-generator": "static-2.7933",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4663",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10885",
  "ui-addon-i18n": "static-1.11041",
  "ui-addon-react-router-dom": "static-1.9438",
  "ui-addon-upgrades": "static-9.17831",
  "ui-asset-management-lib": "static-1.10868",
  "ui-images": "static-2.1127",
  "UIComponents": "static-3.8292",
  "usage-tracker": "static-1.7230",
  "usage-tracker-container": "static-1.7220",
  "usage-tracker-core": "static-1.7080",
  "usage-tracker-public": "static-1.7041",
  "viral-links-lib": "static-1.6932",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven-hubspot": "static-1.6115",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3319",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3137",
  "quartz-webpack": "static-1.3084",
  "ai-components-ui-library": "static-1.8666",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4740",
  "foundations-theming": "static-1.4306",
  "quartz-auth": "static-1.535",
  "ui-business-units-lib": "static-1.8934",
  "usage-tracker-session-replay": "static-1.4916",
  "foundations-theming-base": "static-1.3291",
  "HeadJS": "static-2.734",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3016",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4218",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7818",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3502",
  "persist-promise": "static-1.3602",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.734",
  "hs-story-utils": "static-1.9323",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9717",
  "hubspotter-http": "static-1.4565",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7143",
  "crm-message-bus": "static-1.42684",
  "customer-data-filters-ui-msw-helpers": "static-1.21759",
  "customer-data-objects-ui-components": "static-1.12912",
  "customer-data-reference-ui-components": "static-1.13047",
  "customer-data-ui-utilities": "static-1.9719",
  "framework-builder-read-service-client": "static-1.3921",
  "framework-data-schema-quick-fetch": "static-1.6674",
  "framework-data-schema-resolvers": "static-1.6769",
  "inbound-db-properties-service-client": "static-1.3759",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16406",
  "reporting-datasets-permissions-lib": "static-1.13367",
  "ui-addon-teams": "static-1.21400",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68019",
  "customer-data-properties": "static-1.51163",
  "forms-ai-lib": "static-1.4151",
  "forms-utils-lib": "static-1.12378",
  "foundations-components-test-utils": "static-1.5192",
  "react-dnd-compat": "static-1.4512",
  "react-tinymce": "static-1.54929",
  "tinymce-config": "static-2.54055",
  "ui-gdpr-components": "static-1.10242",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3978",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1516",
  "ui-fonts": "static-1.607",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.818",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.525",
  "quartz-i18n": "static-1.535",
  "quartz-routing": "static-1.290",
  "quartz-test": "static-1.535",
  "quartz-tracking": "static-1.239",
  "batch-promise": "static-1.1445",
  "external-options-client-types": "static-1.4071",
  "react-colorpicker": "static-2.10103",
  "copilot-toolkit": "static-1.10830",
  "data-quality-ui-library": "static-1.12592",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6357",
  "reporting-action-components": "static-1.40960",
  "reporting-insights-lib": "static-1.1399",
  "reporting-plugins": "static-1.10127",
  "ui-addon-draggable-compat": "static-2.4148",
  "ui-addon-opt": "static-4.8276",
  "ui-shepherd-react": "static-3.10041",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25044",
  "hubspot-apollo-client": "static-1.4772",
  "chirp-fetch": "static-1.1775",
  "sales-templates-service-types-lib": "static-1.4079",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5669",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.3991",
  "timezone-utils": "static-2.5138",
  "bender-build-tools": "static-1.3057",
  "chatspot-core": "static-1.20786",
  "bend-plugin-foundations-theming": "static-1.2789",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9715",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3710",
  "crm-pipelines-api-client-types": "static-1.4055",
  "multi-currency-client-types": "static-1.3602",
  "getting-started-shared-tasks": "static-1.18192",
  "growth-data-modal": "static-1.5265",
  "growth-onboarding-confetti": "static-1.2965",
  "growth-onboarding-next-action-utils": "static-1.1599",
  "navigation-components": "static-1.17631",
  "onboarding-tours-client": "static-1.4620",
  "onboarding-tours-utils": "static-1.472",
  "ui-shepherd-tracker": "static-1.7422",
  "ui-universal-auth": "static-1.8826",
  "user-context": "static-1.4993",
  "cms-field-types": "static-1.4703",
  "content-icons-ui": "static-1.2198",
  "integrations-lib": "static-1.15765",
  "calling-global-api": "static-1.64089",
  "calling-internal-common": "static-1.31195",
  "calling-lifecycle-internal": "static-1.65471",
  "calling-lifecycle-messages": "static-1.57765",
  "commerce-products-lib": "static-1.9138",
  "crm-links": "static-1.6169",
  "file-manager-components": "static-1.23278",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.31",
  "inbounddb-objects-service-types": "static-1.4136",
  "meetings-icalendar-utils-lib": "static-1.524",
  "object-builder-ui-client": "static-1.48377",
  "pipeline-validation-client-types": "static-1.3878",
  "property-value-citations": "static-1.1777",
  "pulse": "static-1.431",
  "smart-property-lib": "static-1.6413",
  "tiered-pricing": "static-1.1001",
  "ui-addon-iframeable": "static-1.8943",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19647",
  "tinymce-themes": "static-1.56025",
  "data-token-picker": "static-1.16218",
  "hub-http-contrib": "static-1.2937",
  "interframe": "static-3.4657",
  "tinymce-data": "static-1.40140",
  "tinymce-plugins": "static-1.57169",
  "ui-addon-sales-email": "static-1.5105",
  "magpie-lib": "static-1.5487",
  "magpie-types": "static-1.4947",
  "simple-logging-lib": "static-1.2945",
  "content-assistance-lib": "static-1.7592",
  "dashboard-lib": "static-1.81077",
  "ExportDialog": "static-6.10284",
  "hubspot-prosemirror": "static-1.17926",
  "hubspot-prosemirror-plugins": "static-1.17918",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8588",
  "campaign-roi-lib": "static-1.8620",
  "feedback-loader": "static-1.29098",
  "apollo-link-hub-http": "static-2.4544",
  "hubspot-apollo-cache": "static-1.231",
  "growth-monetization-service-types": "static-1.4395",
  "nav-client-types": "static-1.2252",
  "purchase-motions-api": "static-1.5672",
  "trials-service-types": "static-1.3796",
  "onboarding-data-sync-lib": "static-1.1781",
  "growth-onboarding-next-action-components": "static-1.1627",
  "user-context-client": "static-1.4505",
  "idb-keyval": "static-1.42",
  "nest": "static-1.115",
  "reactive-lib": "static-1.618",
  "unified-auth-core-lib": "static-1.621",
  "getting-started-shared-tasks-store": "static-1.17310",
  "integrations-error-boundary-lib": "static-1.13180",
  "integrations-tracking-lib": "static-1.5489",
  "native-integrations-shared-strings": "static-1.7680",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10267",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.340",
  "calling-error-reporting": "static-1.31201",
  "shared-worker-versioning": "static-1.10932",
  "calling-usage-tracker": "static-1.6435",
  "voice-sms-access-library": "static-1.581",
  "customer-data-tracking": "static-1.6777",
  "commerce-permissions": "static-1.659",
  "products-iframe-lib": "static-1.7628",
  "products-ui-components-shared-msw-handlers": "static-1.10099",
  "location-customization-utils-lib": "static-1.8901",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4047",
  "video-components-external": "static-1.10926",
  "video-data-lib": "static-1.34584",
  "directed-graph": "static-1.831",
  "event-emitter": "static-1.842",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.22",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9800",
  "fsm": "static-1.3627",
  "policy-lib": "static-1.6676",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9863",
  "navigation-messaging": "static-1.6958",
  "FileManagerLib": "static-1.38918",
  "NamespacedHubStyle": "static-2.8981",
  "FileManagerCore": "static-1.38777",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12238",
  "layout-dnd-utils": "static-1.11213",
  "react-codemirror": "static-1.10517",
  "ui-addon-emoji-picker": "static-1.9781",
  "ui-brand-identity-lib": "static-1.14758",
  "ui-addon-video-player": "static-1.8590",
  "ui-coaching-tips": "static-1.28239",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23225",
  "EmailSignatureEditor": "static-1.24139",
  "eligibility-engine-service-types": "static-1.3077",
  "InboxConnectUtils": "static-4.14513",
  "universal-page-editor-lib": "static-1.2900",
  "calling-orchestration-schema": "static-1.35358",
  "sales-views-client-types": "static-1.4157",
  "crm-record-cards-service-types": "static-1.3523",
  "content-media-composition-data-lib": "static-1.11882",
  "content-media-compositions": "static-2.15889",
  "media-bridge-lib": "static-1.18738",
  "trellis-story-utils": "static-1.4413",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5755",
  "FileManagerImages": "static-1.36429",
  "video-components": "static-1.12929",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4425",
  "video-embed": "static-1.35418",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68094",
  "layout-data-lib": "static-1.9538",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6475",
  "commerce-tours-lib": "static-1.5898",
  "growth-onboarding-reliability": "static-1.4980",
  "sales-checkout-service-client": "static-1.3562",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21487",
  "sales-email-signature-service-client": "static-1.3737",
  "social-insights-client-types": "static-1.21760",
  "outpost": "static-1.4089",
  "advanced-menus-core": "static-1.14961",
  "advanced-menus-lib": "static-1.11924",
  "ui-memberships-settings-lib": "static-1.33746",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14960",
  "simple-menus-lib": "static-1.16477"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34233",
  "client-types": "/client-types/static-1.456",
  "documents-lib": "/documents-lib/static-1.34238",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2022",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4921",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5488",
  "hs-test-utils": "/hs-test-utils/static-1.7905",
  "hub-http": "/hub-http/static-1.6112",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11345",
  "I18n": "/I18n/static-7.1600",
  "jasmine-immutable": "/jasmine-immutable/static-1.2911",
  "jasmine-runner": "/jasmine-runner/static-1.6363",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6860",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.76",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16548",
  "reporting-data": "/reporting-data/static-1.66997",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8930",
  "reporting-visualizations": "/reporting-visualizations/static-1.59073",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4663",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4964",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2387",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.766",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39324",
  "customer-data-objects": "/customer-data-objects/static-1.7550",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7977",
  "data-fetching-client": "/data-fetching-client/static-1.9569",
  "enviro": "/enviro/static-4.425",
  "FireAlarmUi": "/FireAlarmUi/static-1.4423",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85562",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4613",
  "foundations-components": "/foundations-components/static-1.7709",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11653",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.76",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7053",
  "metrics-js": "/metrics-js/static-1.9522",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "property-description-translator": "/property-description-translator/static-1.3747",
  "property-translator": "/property-translator/static-1.5302",
  "quartz-config": "/quartz-config/static-1.638",
  "quartz-core": "/quartz-core/static-1.6079",
  "quick-fetch": "/quick-fetch/static-1.3828",
  "raven": "/raven/static-3.5808",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5261",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8060",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7983",
  "report-customization-components": "/report-customization-components/static-1.12820",
  "reporting-enablement": "/reporting-enablement/static-1.22488",
  "reporting-reports": "/reporting-reports/static-1.66675",
  "reporting-snowflake": "/reporting-snowflake/static-1.55615",
  "reporting-ui-components": "/reporting-ui-components/static-2.64268",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4537",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8831",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9074",
  "sanitize": "/sanitize/static-1.4366",
  "sanitize-text": "/sanitize-text/static-1.8038",
  "self-service-api": "/self-service-api/static-1.10139",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1645",
  "signup-constants": "/signup-constants/static-1.18643",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20653",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7933",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4663",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10885",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11041",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9438",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17831",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10868",
  "ui-images": "/ui-images/static-2.1127",
  "UIComponents": "/UIComponents/static-3.8292",
  "usage-tracker": "/usage-tracker/static-1.7230",
  "usage-tracker-container": "/usage-tracker-container/static-1.7220",
  "usage-tracker-core": "/usage-tracker-core/static-1.7080",
  "usage-tracker-public": "/usage-tracker-public/static-1.7041",
  "viral-links-lib": "/viral-links-lib/static-1.6932",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3319",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3137",
  "quartz-webpack": "/quartz-webpack/static-1.3084",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8666",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4740",
  "foundations-theming": "/foundations-theming/static-1.4306",
  "quartz-auth": "/quartz-auth/static-1.535",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8934",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4916",
  "foundations-theming-base": "/foundations-theming-base/static-1.3291",
  "HeadJS": "/HeadJS/static-2.734",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3016",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4218",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7818",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3502",
  "persist-promise": "/persist-promise/static-1.3602",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.734",
  "hs-story-utils": "/hs-story-utils/static-1.9323",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9717",
  "hubspotter-http": "/hubspotter-http/static-1.4565",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7143",
  "crm-message-bus": "/crm-message-bus/static-1.42684",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21759",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12912",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13047",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9719",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3921",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6674",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6769",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3759",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16406",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13367",
  "ui-addon-teams": "/ui-addon-teams/static-1.21400",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68019",
  "customer-data-properties": "/customer-data-properties/static-1.51163",
  "forms-ai-lib": "/forms-ai-lib/static-1.4151",
  "forms-utils-lib": "/forms-utils-lib/static-1.12378",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5192",
  "react-dnd-compat": "/react-dnd-compat/static-1.4512",
  "react-tinymce": "/react-tinymce/static-1.54929",
  "tinymce-config": "/tinymce-config/static-2.54055",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10242",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3978",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1516",
  "ui-fonts": "/ui-fonts/static-1.607",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.818",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.525",
  "quartz-i18n": "/quartz-i18n/static-1.535",
  "quartz-routing": "/quartz-routing/static-1.290",
  "quartz-test": "/quartz-test/static-1.535",
  "quartz-tracking": "/quartz-tracking/static-1.239",
  "batch-promise": "/batch-promise/static-1.1445",
  "external-options-client-types": "/external-options-client-types/static-1.4071",
  "react-colorpicker": "/react-colorpicker/static-2.10103",
  "copilot-toolkit": "/copilot-toolkit/static-1.10830",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12592",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6357",
  "reporting-action-components": "/reporting-action-components/static-1.40960",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1399",
  "reporting-plugins": "/reporting-plugins/static-1.10127",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4148",
  "ui-addon-opt": "/ui-addon-opt/static-4.8276",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10041",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25044",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4772",
  "chirp-fetch": "/chirp-fetch/static-1.1775",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4079",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5669",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.3991",
  "timezone-utils": "/timezone-utils/static-2.5138",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "chatspot-core": "/chatspot-core/static-1.20786",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2789",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9715",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3710",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4055",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3602",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18192",
  "growth-data-modal": "/growth-data-modal/static-1.5265",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2965",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1599",
  "navigation-components": "/navigation-components/static-1.17631",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4620",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.472",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7422",
  "ui-universal-auth": "/ui-universal-auth/static-1.8826",
  "user-context": "/user-context/static-1.4993",
  "cms-field-types": "/cms-field-types/static-1.4703",
  "content-icons-ui": "/content-icons-ui/static-1.2198",
  "integrations-lib": "/integrations-lib/static-1.15765",
  "calling-global-api": "/calling-global-api/static-1.64089",
  "calling-internal-common": "/calling-internal-common/static-1.31195",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65471",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57765",
  "commerce-products-lib": "/commerce-products-lib/static-1.9138",
  "crm-links": "/crm-links/static-1.6169",
  "file-manager-components": "/file-manager-components/static-1.23278",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.31",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4136",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.524",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48377",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3878",
  "property-value-citations": "/property-value-citations/static-1.1777",
  "pulse": "/pulse/static-1.431",
  "smart-property-lib": "/smart-property-lib/static-1.6413",
  "tiered-pricing": "/tiered-pricing/static-1.1001",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8943",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19647",
  "tinymce-themes": "/tinymce-themes/static-1.56025",
  "data-token-picker": "/data-token-picker/static-1.16218",
  "hub-http-contrib": "/hub-http-contrib/static-1.2937",
  "interframe": "/interframe/static-3.4657",
  "tinymce-data": "/tinymce-data/static-1.40140",
  "tinymce-plugins": "/tinymce-plugins/static-1.57169",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5105",
  "magpie-lib": "/magpie-lib/static-1.5487",
  "magpie-types": "/magpie-types/static-1.4947",
  "simple-logging-lib": "/simple-logging-lib/static-1.2945",
  "content-assistance-lib": "/content-assistance-lib/static-1.7592",
  "dashboard-lib": "/dashboard-lib/static-1.81077",
  "ExportDialog": "/ExportDialog/static-6.10284",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17926",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17918",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8588",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8620",
  "feedback-loader": "/feedback-loader/static-1.29098",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4544",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.231",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4395",
  "nav-client-types": "/nav-client-types/static-1.2252",
  "purchase-motions-api": "/purchase-motions-api/static-1.5672",
  "trials-service-types": "/trials-service-types/static-1.3796",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1781",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1627",
  "user-context-client": "/user-context-client/static-1.4505",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.115",
  "reactive-lib": "/reactive-lib/static-1.618",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.621",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17310",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13180",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5489",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7680",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10267",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.340",
  "calling-error-reporting": "/calling-error-reporting/static-1.31201",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10932",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6435",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.581",
  "customer-data-tracking": "/customer-data-tracking/static-1.6777",
  "commerce-permissions": "/commerce-permissions/static-1.659",
  "products-iframe-lib": "/products-iframe-lib/static-1.7628",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10099",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8901",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4047",
  "video-components-external": "/video-components-external/static-1.10926",
  "video-data-lib": "/video-data-lib/static-1.34584",
  "directed-graph": "/directed-graph/static-1.831",
  "event-emitter": "/event-emitter/static-1.842",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.22",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9800",
  "fsm": "/fsm/static-1.3627",
  "policy-lib": "/policy-lib/static-1.6676",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9863",
  "navigation-messaging": "/navigation-messaging/static-1.6958",
  "FileManagerLib": "/FileManagerLib/static-1.38918",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8981",
  "FileManagerCore": "/FileManagerCore/static-1.38777",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12238",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11213",
  "react-codemirror": "/react-codemirror/static-1.10517",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9781",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14758",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8590",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28239",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23225",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24139",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3077",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14513",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2900",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35358",
  "sales-views-client-types": "/sales-views-client-types/static-1.4157",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3523",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11882",
  "content-media-compositions": "/content-media-compositions/static-2.15889",
  "media-bridge-lib": "/media-bridge-lib/static-1.18738",
  "trellis-story-utils": "/trellis-story-utils/static-1.4413",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5755",
  "FileManagerImages": "/FileManagerImages/static-1.36429",
  "video-components": "/video-components/static-1.12929",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4425",
  "video-embed": "/video-embed/static-1.35418",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68094",
  "layout-data-lib": "/layout-data-lib/static-1.9538",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6475",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5898",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4980",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3562",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21487",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3737",
  "social-insights-client-types": "/social-insights-client-types/static-1.21760",
  "outpost": "/outpost/static-1.4089",
  "advanced-menus-core": "/advanced-menus-core/static-1.14961",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11924",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33746",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14960",
  "simple-menus-lib": "/simple-menus-lib/static-1.16477"
}
};
